import { createFileRoute } from "@tanstack/react-router";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import AdminPressureWasherEdit from "@/pages/admin/AdminPressureWasherEdit";

export const Route = createFileRoute("/admin/pressure-washers/$id")({
  component: () => (
    <ProtectedRoute>
      <AdminPressureWasherEdit />
    </ProtectedRoute>
  ),
});
